(function () {
  if (!window.CfonElements) return;

  // content-text with a Klaviyo form ID: the block opens that onsite form instead of linking out.
  class CfonKlaviyoForm extends CfonElements.Component {
    onConnect() {
      this.formId = this.dataset.formId;
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    // Swiper's loopFix moves slides in the DOM, so drop the listeners on every disconnect.
    onDisconnect() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeydown);
    }

    onClick(event) {
      if (!this.formId) return;
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', this.formId]);
    }

    // role="button" has to answer Enter and Space the way a real button does.
    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      this.onClick(event);
    }
  }

  CfonElements.define('cfon-klaviyo-form', CfonKlaviyoForm);
})();
